import { PermissionsEnum } from '@/auth/interfaces';
import { useCheckPermissions } from '@/shared';
import { SavePlan } from '../../shared/components';

export type CreatePlanPageProps = {};

const CreatePlanPage: React.FC<CreatePlanPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_add_plan);

  return <SavePlan titlePage="Crear Plan" />;
};

export default CreatePlanPage;
